import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";

import Checkbox from "../../components/checkbox/checkbox";
import CheckboxGroup from "../../components/checkboxGroup/checkboxGroup";
import Tooltip from "../../components/localForms/tooltip";
import SimpleRichText from "../text/simpleRichText";

const KontentItemInputTypeCheckbox = ({
  data: { elements },
  errors,
  touched,
  meta,
  onBlur,
  onChange,
  children,
  values,
}) => {
  if (elements.group_label.value.length > 0) {
    return (
      <Col xs={12} className="form-group">
        <Tooltip id={elements.id.value} tooltipMessage={elements.tooltip.value}>
          <CheckboxGroup
            label={elements.group_label.value}
            description={elements.group_description.value}
            isInvalid={errors[elements.group_id.value] && touched[elements.group_id.value]}
            inline={elements.group_inline.value.length > 0 && elements.group_inline.value[0].codename === "true"}
            invalidFeedback={errors[elements.group_id.value]}
            required={meta.requiredFields.includes(elements.group_id.value)}
          >
            {children?.map((el) => (
              <Checkbox
                key={el.id}
                label={<SimpleRichText data={el.elements.label} openLinksInNewTab />}
                id={el.elements.id.value}
                name={elements.group_id.value}
                onChange={onChange}
                onBlur={onBlur}
                isInvalid={errors[elements.group_id.value] && touched[elements.group_id.value]}
                value={el.elements.label.value}
                checked={
                  values[elements.group_id.value].length > 0
                  && (values[elements.group_id.value] === el.elements.label.value
                    || values[elements.group_id.value].includes(el.elements.label.value))
                }
              />
            ))}
          </CheckboxGroup>
        </Tooltip>
      </Col>
    );
  }

  return (
    <Col xs={12} className="form-group">
      <Tooltip id={elements.id.value} tooltipMessage={elements.tooltip.value}>
        <CheckboxGroup
          label={elements.group_label.value}
          description={elements.group_description.value}
          isInvalid={errors[elements.group_id.value] && touched[elements.group_id.value]}
          inline={elements.group_inline.value.length > 0 && elements.group_inline.value[0].codename === "true"}
          invalidFeedback={errors[elements.group_id.value]}
          required={meta.requiredFields.includes(elements.group_id.value)}
        >
          <Checkbox
            label={<SimpleRichText data={elements.label} openLinksInNewTab />}
            id={elements.id.value}
            name={elements.id.value}
            onChange={onChange}
            onBlur={onBlur}
            isInvalid={errors[elements.id.value] && touched[elements.id.value]}
            invalidFeedback={errors[elements.id.value]}
            checked={values[elements.id.value].length > 0 || values[elements.id.value]}
            required={meta.requiredFields.includes(elements.id.value)}
          />
        </CheckboxGroup>
      </Tooltip>
    </Col>
  );
};

export const query = graphql`
  fragment KontentItemInputTypeCheckbox on kontent_item_input_type_checkbox {
    id
    elements {
      id {
        value
      }
      label {
        name
        value
        links {
          codename
          link_id
          type
          url_slug
        }
        images {
          description
          height
          image_id
          url
          width
        }
      }
      required {
        value {
          codename
        }
      }
      tooltip {
        value
      }
      group_description {
        value
      }
      group_id {
        value
      }
      group_inline {
        value {
          codename
        }
      }
      group_label {
        value
      }
      group_max_allowed {
        value {
          name
        }
      }
      group_min_required {
        value {
          name
        }
      }
    }
  } 
`;

KontentItemInputTypeCheckbox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object]).isRequired,
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  meta: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  touched: PropTypes.oneOfType([PropTypes.object]).isRequired,
  values: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemInputTypeCheckbox;
